import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=3d46fe70&scoped=true&"
import script from "./ChangeHistory.vue?vue&type=script&lang=ts&"
export * from "./ChangeHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=3d46fe70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46fe70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
